import React from "react";

const tanishq_borkar = () => {
  return (
    <div>
      <h1>Tanishq Borkar</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        1st Round(Aptitude Test) : Everyone with 7+ CGPA and No backlogs
        <br />
        2nd Round(Technical Interview): Based on performance in Aptitude Round
        <br />
        3rd Round(HR Round): Based on performance in Technical Interview{" "}
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        1) Pre-placement talk followed by Aptitude Test: On 03/09/2025 at
        10:30AM
        <br />
        2) Technical Interview : On 04/09/2025 around 09:00AM
        <br />
        3) HR Round : Just after the Technical Round
        <br />
        Results were announced on the same day(04/09/2025) around 01:15PM
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The Aptitude Test took place in Cognizant Lab and it consisted of 2
        sections
        <br />
        and a time limit of 80 min for the whole test.
      </p>

      <p>
        1) 30 MCQ which covered various topics like Cloud Infrastructure,
        Software Development Lifecycle,Computer Networks,DSA,OOPS,DBMS.
        <br />
        Also questions from Time and Work were asked so do practise Arithmetic
        Aptitude Questions.
      </p>

      <p>
        2) 2 Coding Questions: Both the questions were easy and mostly tested
        string manipulation and greedy.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        15 students were shortlisted after Aptitude Round
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The results of the Aptitude Round were declared around 5PM and the
        interviews were scheduled the very next day in the morning , so we had
        <br />
        limited time to prepare for interviews.
        <br />
        I focused mainly on the projects I had done (DSA Project + a project
        related to Computer Networks), also I practised some DSA questions which
        could be asked based on my DSA project.
        <br />
        Finally, I also prepared for questions which could be asked related to
        BP
        <br />
        and personal questions like Hobbies,Interests,etc.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        There were 2 Interview Rounds in total
        <br />
        1) Technical Interview (1hr 15 min):
        <br />
        Questions spanning almost all CS Topics were asked
      </p>

      <p>
        Projects:
        <br />
        For my DSA project which was a Spell Checker I was asked to explain my
        approach and also design decisions I took. Also I had to explain how my
        approach stood amongst the other approaches for Spell Checkers.
        <br />
        For my CN related project I was asked similar questions and along with
        that
        <br />I was also asked to map my project along the lines of the OSI
        model going through each layer.
      </p>

      <p>
        DSA:
        <br />
        Basic Questions like difference between Linked List and Arrays, What are
        Binary Trees, Ternary Search Trees(This was used in my project).
        <br />2 Coding Questions (on a paper) were asked as well
      </p>

      <ul>
        <li>Reverse a LinkedList using Recursion </li>
        <li>Print the nth Fibonacci Number</li>
      </ul>

      <p>
        DBMS:
        <br />
        - Writing a SQL query to get the top 3 entries based on a given
        attribute.
        <br />
        - What are ACID properties?
        <br />- Explain Transaction Management.
      </p>

      <p>
        CN:
        <br />
        - Explain OSI model and TCP/IP model.
        <br />
        - When we visit a website how exactly do we go through all these layers
        <br />
        and what exactly happens at each layer.
      </p>

      <p>
        OS:
        <br />
        - Explain deadlocks.
        <br />- How did I avoid deadlocks in my CN project (as I used
        multithreading in it).
      </p>

      <p>
        Questions related to Cloud Architecture like what is Cloud exactly and
        why it is used.Also I was asked questions on Software Development Life
        Cycles like
        <br />
        What is AGILE methodology, What are sprints, What are story points, etc
      </p>

      <p>
        Lastly I was asked some behavioral questions
        <br />
        - How will I resolve a conflict in a team?
        <br />
        - What are my strengths and weaknesses and what am I doing to overcome
        these weaknesses?
        <br />- Where do I see myself in 5 years?
      </p>

      <p>
        After the Technical Interview , around 8-9 students were shortlisted for
        the HR interview.
      </p>

      <p>
        2) HR Interview (10-15 min):
        <br />
        Mostly Behavioral Questions were asked
        <br />
        - Why BP?
        <br />
        - Why should we select you among all the candidates?
        <br />
        (This question tests your confidence and self-belief so make sure to
        answer assertively, without showing even a hint of doubt.)
      </p>

      <p>
        After the HR Interview, 5 students were selected for the internship.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
      </p>

      <p>
        The interviewer primarily focused on project-related skills , in my
        case, topics related to Computer Networks and Data Structures &amp;
        Algorithms. Having a good understanding of Cloud Infrastructure can also
        be an added advantage, as the overall interview tended to lean towards
        networking concepts.
      </p>

      <p>
        Ensure that you know at least the basics of cloud architecture as
        questions related to this are asked in both aptitude round and technical
        interview.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        DSA: Striver A2Z DSA sheet, Aditya Verma’s Youtube Channel for DP
        <br />
        DBMS: Gate Smashers DBMS playlist, SQL 50 on leetcode for SQL practise
        <br />
        CN: Computer Networking Tutorial from Bogdan Stashchuck on youtube
        <br />
        OS: Love Babbar’s OS notes, Abhijit Sir’s lectures on ‘Sparkle’ Youtube
        Channel
        <br />
        Cloud Computing: I did not prepare for this that well, just watched
        <br />
        45 min Cloud Computing video on youtube and it seemed enough at this
        level
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        1) My suggestion would be to first choose a programming language you are
        completely comfortable with and understand its syntax well. Practice
        string manipulation problems in your preferred language, as they often
        appear as minor parts of larger coding problems , such as while reading
        inputs or formatting outputs and can cause unnecessary mistakes if not
        handled confidently.
        <br />
        2) Keep revising DSA problems you solved earlier instead of just rushing
        for more problems.
        <br />
        3) Give contests on Leetcode,Codeforces for timebounded practice and
        start this thing as early as possible during the preparation phase.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        I was asked a lot of questions which were directly or indirectly
        connected with my projects, so ensure that you are thorough with all the
        aspects of your projects.
        <br />I was not asked questions related to clubs and extracurricular
        activities.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Prepare for questions related to BP from their website and also pay
        attention in the pre-placement talks which take place before the
        aptitude round for further preparations.
        <br />
        Ask questions after each interview, could be related to the company or
        any concept you did not get while in the interview.
        <br />
        Finally, don’t forget to ask the interviewer for feedback after your
        interview. It helps you understand your strengths and identify areas for
        improvement, which can be valuable for future interviews.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        - Prepare a good introduction and try to guide the interviewer towards
        your stronger topics.
        <br />
        - Don’t use too much technical jargon while answering questions as this
        gives interviewers an opportunity to cross question you.
        <br />
        - While solving questions in interviews, always explain each step and
        your reasoning behind it. Never become silent while solving questions.
        <br />
        - Never be negative in how you construct your answers especially during
        HR Rounds. Always be definite and assertive.
        <br />
        - If you are unsure about a topic, it’s better to clarify or admit it to
        the interviewer rather than provide an incorrect answer.
        <br />- Be mindful of your body language and the tone of your speech, as
        both leave a strong impression on the interviewer.
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Phone No :</strong> 8830792939
        <br />
        <strong>Email :</strong> <a href="mailto:borkartn23.comp@coeptech.ac.in">borkartn23.comp@coeptech.ac.in</a>
        <br />
        <strong>LinkedIn :</strong>{" "}
        <a href="https://www.linkedin.com/in/tanishq-borkar-948773216/">
          Tanishq Borkar
        </a>
      </p>
    </div>
  );
};

export default tanishq_borkar;
